// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1eCFP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1rKhB","obliqueLine":"membershipbadge_obliqueLine__HsG4m"};